import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["fill"]


const __default__ = {};

interface Props {
  width?: number;
  height?: number;
  fill?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IconHealthCare',
  props: {
    width: { default: 24 },
    height: { default: 24 },
    fill: { default: "#E11D23" }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: _ctx.width,
    height: _ctx.height,
    viewBox: `0 0 ${_ctx.width} ${_ctx.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M22.1379 8.25856H15.7414V1.86207C15.7414 1.76604 15.7033 1.67395 15.6354 1.60605C15.5675 1.53815 15.4754 1.5 15.3794 1.5H8.62063C8.52461 1.5 8.43252 1.53815 8.36461 1.60605C8.29671 1.67395 8.25857 1.76604 8.25856 1.86207V8.25856H1.86207C1.76604 8.25857 1.67395 8.29671 1.60605 8.36461C1.53815 8.43252 1.5 8.52461 1.5 8.62063V15.3794C1.5 15.4754 1.53815 15.5675 1.60605 15.6354C1.67395 15.7033 1.76604 15.7414 1.86207 15.7414H8.25856V22.1379C8.25857 22.234 8.29671 22.326 8.36461 22.3939C8.43252 22.4618 8.52461 22.5 8.62063 22.5H15.3794C15.4754 22.5 15.5675 22.4618 15.6354 22.3939C15.7033 22.326 15.7414 22.234 15.7414 22.1379V15.7414H22.1379C22.234 15.7414 22.326 15.7033 22.3939 15.6354C22.4618 15.5675 22.5 15.4754 22.5 15.3794V8.62063C22.5 8.52461 22.4618 8.43252 22.3939 8.36461C22.326 8.29671 22.234 8.25857 22.1379 8.25856Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})